/**
 * CLI auth selectors — browser authorization flow used by `segmently auth login`.
 */

export const CLI_AUTH = {
  page: 'cli-auth-page',
  authorizeButton: 'cli-auth-authorize-button',
  status: 'cli-auth-status',
  error: 'cli-auth-error',
} as const;
